import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { CORE_LINE, FAQ_ITEMS, faqPageJsonLd } from "@/content/faq";

export const Route = createFileRoute("/faq")({
  head: () =>
    seoHead({
      title: "Parent FAQ: Behavioural & Life Skills",
      description:
        "Answers on LeadXkids behavioural and life skills courses for kids 8–14 in India: SEL, confidence, anger, emotions, price and age.",
      canonical: "/faq",
      pageType: "FAQPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "FAQ", url: "/faq" },
        ]),
        faqPageJsonLd(),
      ],
    }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <div className="min-h-dvh flex flex-col bg-background">
      <Header />
      <main id="main-content" className="flex-1">
        <article className="container mx-auto px-4 py-10 max-w-3xl">
          <h1 className="lx-h1 mb-3">Parent questions about LeadXkids</h1>
          <p data-speakable className="text-base sm:text-lg text-muted-foreground mb-8">{CORE_LINE}</p>
          <div className="space-y-3">
            {FAQ_ITEMS.map((f) => (
              <details key={f.q} className="rounded-lg border bg-card p-4">
                <summary className="font-semibold cursor-pointer text-foreground">
                  <h2 className="inline text-base">{f.q}</h2>
                </summary>
                <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">{f.a}</p>
              </details>
            ))}
          </div>
          <p className="mt-10 text-[15px] text-muted-foreground">
            For more detail, read <Link className="text-primary underline" to="/for-parents">LeadXkids for Parents</Link>.{" "}
            Still have a question? Read <a className="text-primary underline" href="/about">about LeadXkids</a>, browse{" "}
            <a className="text-primary underline" href="/courses">all courses</a>, or write to{" "}
            <a className="text-primary underline" href="mailto:hello@leadxkids.com">hello@leadxkids.com</a>.
          </p>
        </article>
      </main>
    </div>
  );
}
